export const COMPANY_NAME = 'FRIENDS OF CINCINNATI CLASSICAL ACADEMY';
export const COMPANY_SHORT = 'Friends of CCA';
export const COMPANY_ADDRESS_FULL = '170 SIEBENTHALER AVE, CINCINNATI, OH 45215-3715';
export const COMPANY_LOCATION = 'Cincinnati, Ohio';
export const MAP_URL =
  'https://www.google.com/maps/search/?api=1&query=170%20SIEBENTHALER%20AVE%2C%20CINCINNATI%2C%20OH%2045215-3715';
export const HERO_IMAGE_URL =
  'https://cdn.sanity.io/images/f3esye2w/production/bf7716277b0f310a9921a088bc114f008a032d06-2596x1696.webp';
export const HERO_IMAGE_SOURCE_URL = 'https://www.usdigitalpartners.com/work/2024/cincinnati-classical-academy';

export const PROFILE_FACTS = [
  { label: 'Role', value: 'Development & advancement support' },
  { label: 'Community', value: 'Cincinnati Classical Academy' },
  { label: 'Location', value: COMPANY_LOCATION },
];

export const PUBLIC_INFO = [
  { label: 'Organization', value: COMPANY_NAME },
  { label: 'City / State', value: COMPANY_LOCATION },
  { label: 'Address', value: COMPANY_ADDRESS_FULL },
];

export const ADVANCEMENT_FOCUS = [
  {
    number: '01',
    title: 'Advancement Focus',
    body: 'Friends is presented as a supporting organization for development, awareness, gifts, and school-community advancement.',
  },
  {
    number: '02',
    title: 'Classical Education Context',
    body: 'The layout reflects the academy language of classical liberal arts, civic virtue, and a time-tested tradition.',
  },
  {
    number: '03',
    title: 'Public-Safe Directory Data',
    body: 'The profile keeps the supplied address visible while private registry and tax identifiers remain out of the client page.',
  },
];
